import { render, staticRenderFns } from "./DialogContactSelector.vue?vue&type=template&id=3994b6c4"
import script from "./DialogContactSelector.vue?vue&type=script&lang=js"
export * from "./DialogContactSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports